<template>
  <div id="satisfactionLevelWrap" v-if="languages" :style="{ fontFamily: languages === 'en' ? 'Arial' : '宋体'}">
    <div class="satisfactionLevel">
      <img src="../../assets/logo1.png" class="logo" />
      <div v-if="!deadlineMsg">
        <h1>{{ languages === 'en' ? 'H3C Customer Satisfaction Survey' : 'H3C客户满意度调查' }}</h1>
        <div class="titletips" v-if="languages === 'en'">
          Based on your recent service experience with the <span>{{projectName}}</span>，please feedback through below questionnaire and help us to improve our product and service quality.<br/>Thank you very much for your support.<br/>
          Note：Questions marked with an asterisk are required.
        </div>
        <div class="titletips" v-else>
          请根据您最近 <span>{{projectName}}</span> 的服务体验，反馈以下问卷，帮助我们改善我们的产品和服务质量。<br/>非常感谢您的支持。<br/>
          说明：带星号的问题为必填项。
        </div>
        <el-form :model="form" ref="form" >
          <el-row v-for="(question, index) in form.questionList" :key="index">
            <el-col :span="24">
              <el-form-item
                :label="question.questionText"
                :prop="'questionList.' + index + '.value'"
                :rules="{
                  required: question.required, message: 'Please select'
                }"
              >
                <el-radio-group clearable v-model="question.value" placeholder="Please select" v-if="question.questionType === 'single_choice'">
                  <el-radio v-for="item in question.options" :label="item.optionValue" :key="item.optionValue">{{ item.optionText }}</el-radio>
                </el-radio-group>
                <el-input
                  type="textarea"
                  clearable
                  maxlength="2000"
                  v-model="question.value"
                  :rows="3"
                  :placeholder="languages === 'en' ? 'Please enter up to 2000 words' : '最多输入2000字'"
                  v-else
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24" style="text-align: center">
              <el-button type="primary" :loading="submitLoading" @click="handleSubmit">{{ languages === 'en' ? 'Submit' : '提交' }}</el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="deadlinebox" v-else>
        <h2 v-html="deadlineMsg"></h2>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'satisfactionlevel',
    data () {
      return {
        guid: '',
        languages: 'en',
        projectName: '',
        editDisabled: false,
        form: {
					questionList: [],
				},
        submitLoading: false,
        deadlineMsg: '',
      }
    },
    created () {
      this.guid = this.$route.query.guid;
      this.languages = this.$route.query.lang;
      this.getQuestionData();
    },
    methods: {
      getQuestionData() {
        let url =`${this.$store.state.islhurl}major-project-survey/portal-survey?guid=${this.guid}&lang=${this.languages}`;
        this._get(url).then(
          res => {
            if (res.code === 201) {
              this.deadlineMsg = res.message;
            } else if(res.code === 200 && res.data) {
              let questionList = []
              res.data.questions && res.data.questions.forEach(item => {
                questionList.push({
                  ...item,
                  value: item.answer ? item.answer.optionValue : '',
                })
              });
              this.form.questionList = questionList;
              this.projectName = res.data.projectName;
            }
          }
        )
      },
      handleSubmit() {
        this.$refs.form.validate((valid) => {
					if (valid) {
						const values = this.form;
            let answers = []
            if(values.questionList) {
              values.questionList.forEach(item => {
                answers.push({
                  questionId: item.id,
                  answerText: item.value,
                })
              })
            }
            this.submitLoading = true
            let params = {
              guid: this.guid,
              submittedLanguage: this.languages,
              answers,
            }
            let url =`${this.$store.state.islhurl}major-project-survey/submit-survey`;
            this._post(url, params).then(
              res => {
                this.submitLoading = false
                if (res.code === 200) {
                  this.$message.success('Submit successful!');
                  this.getQuestionData();
                } else {
							    this.$message.error(res.message || 'Failed!' );
                }
              }).catch(() => {
                this.submitLoading = false
							  this.$message.error('Failed!' );
              }
            );
					} else {
						return false;
					}
				});
      },
    },
  }
</script>
<style lang="less" scoped>
#satisfactionLevelWrap {
  padding: 30px 0;
  background-image: url('../../assets/banner.jpg');
  background-size: 100% auto;
  min-height: 100vh;
  .satisfactionLevel {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    font-size: 16px;
    color: #333;
    background-color: #fff;
    position: relative;
    min-height: 85vh;
    .logo {
      position: absolute;
      top: 15px;
      left: 15px;
    }
    h1 {
      text-align: center;
      color: #409EFF;
      font-size: 30px;
      padding: 16px 0 26px 50px;
      line-height: 33px;
    }
    .titletips {
      margin-bottom: 20px;
      line-height: 26px;
      span {
        color: #409EFF;
      }
    }
    /deep/.el-form-item__label {
      text-align: left;
      font-size: 16px;
      color: #333;
      width: 100%;
      line-height: 20px;
      padding: 10px 0;
    }
    /deep/.el-form-item__content {
      margin-left: 0 !important;
      color: #333;
    }
    /deep/.el-radio__label {
      font-size: 16px;
      color: #333;
      font-weight: normal;
    }
    /deep/.el-form-item {
      background-color: #f9f9f9;
      padding: 5px 10px;
      margin-bottom: 15px;
    }
    /deep/.el-textarea {
      margin-bottom: 10px;
    }
    .deadlinebox h2 {
      font-size: 20px;
      padding-top: 30vh;
      text-align: center;
      line-height: 35px;
    }
  }
}
@media (max-width: 575px) {
  #satisfactionLevelWrap {
    padding: 0;
    background: #fff;
    /deep/.el-radio {
      padding: 5px 0;
      width: 100%;
    }
  }
}
@media (max-width: 375px) {
  #satisfactionLevelWrap {
    .logo {
      width: 50px;
      height: auto;
      top: 25px!important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/satisfactionlevel/index.vue